export enum PortalOccupancyType {
	Primary = 'Primary',
	SecondHome = '2nd Home',
	Investment = 'Investment'
}

export enum PortalOccupancyTypeCOC {
	PrimaryResidence = 'Primary Residence',
	SecondaryResidence = 'Secondary Residence',
	Investment = 'Investment'
}
